
import { Base } from '../base-component';

import './search-results-item.component.scss';

export class SearchResultsItem extends Base {

	constructor(element: Element){

		super(element);
				
	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/search-results-item/search-results-item.component.ts